import { TerminalInterface } from 'store/ducks/terminals/types';
import { LineInterface } from 'store/ducks/lines/types';

/*
 * Action Types
 */
export enum TerminalBlocksTypes {
  LIST_TERMINAL_BLOCKS_REQUEST = '@terminalBlocks/LIST_TERMINAL_BLOCKS_REQUEST',
  LIST_TERMINAL_BLOCKS_SUCCESS = '@terminalBlocks/LIST_TERMINAL_BLOCKS_SUCCESS',
  LIST_TERMINAL_BLOCKS_FAILURE = '@terminalBlocks/LIST_TERMINAL_BLOCKS_FAILURE',

  TOGGLE_BLOCK_SCHEDULE_STATUS_REQUEST = '@terminalBlocks/TOGGLE_BLOCK_SCHEDULE_STATUS_REQUEST',
  TOGGLE_BLOCK_SCHEDULE_STATUS_SUCCESS = '@terminalBlocks/TOGGLE_BLOCK_SCHEDULE_STATUS_SUCCESS',
  TOGGLE_BLOCK_SCHEDULE_STATUS_FAILURE = '@terminalBlocks/TOGGLE_BLOCK_SCHEDULE_STATUS_FAILURE',

  TOGGLE_TERMINAL_PANIC_REQUEST = '@terminalBlocks/TOGGLE_TERMINAL_PANIC_REQUEST',
  TOGGLE_TERMINAL_PANIC_SUCCESS = '@terminalBlocks/TOGGLE_TERMINAL_PANIC_SUCCESS',
  TOGGLE_TERMINAL_PANIC_FAILURE = '@terminalBlocks/TOGGLE_TERMINAL_PANIC_FAILURE',

  CREATE_BLOCK_SCHEDULE_REQUEST = '@terminalBlocks/CREATE_BLOCK_SCHEDULE_REQUEST',
  CREATE_BLOCK_SCHEDULE_SUCCESS = '@terminalBlocks/CREATE_BLOCK_SCHEDULE_SUCCESS',
  CREATE_BLOCK_SCHEDULE_FAILURE = '@terminalBlocks/CREATE_BLOCK_SCHEDULE_FAILURE',

  UPDATE_BLOCK_SCHEDULE_REQUEST = '@terminalBlocks/UPDATE_BLOCK_SCHEDULE_REQUEST',
  UPDATE_BLOCK_SCHEDULE_SUCCESS = '@terminalBlocks/UPDATE_BLOCK_SCHEDULE_SUCCESS',
  UPDATE_BLOCK_SCHEDULE_FAILURE = '@terminalBlocks/UPDATE_BLOCK_SCHEDULE_FAILURE',

  DELETE_BLOCK_SCHEDULE_REQUEST = '@terminalBlocks/DELETE_BLOCK_SCHEDULE_REQUEST',
  DELETE_BLOCK_SCHEDULE_SUCCESS = '@terminalBlocks/DELETE_BLOCK_SCHEDULE_SUCCESS',
  DELETE_BLOCK_SCHEDULE_FAILURE = '@terminalBlocks/DELETE_BLOCK_SCHEDULE_FAILURE',

  BLOCK_SCHEDULE_GATE_CREATE_REQUEST = '@terminalBlocks/BLOCK_SCHEDULE_GATE_CREATE_REQUEST',
  BLOCK_SCHEDULE_GATE_CREATE_SUCCESS = '@terminalBlocks/BLOCK_SCHEDULE_GATE_CREATE_SUCCESS',
  BLOCK_SCHEDULE_GATE_CREATE_FAILURE = '@terminalBlocks/BLOCK_SCHEDULE_GATE_CREATE_FAILURE',

  GET_TERMINAL_BLOCK_REQUEST = '@terminalBlocks/GET_TERMINAL_BLOCK_REQUEST',
  GET_TERMINAL_BLOCK_SUCCESS = '@terminalBlocks/GET_TERMINAL_BLOCK_SUCCESS',
  GET_TERMINAL_BLOCK_FAILURE = '@terminalBlocks/GET_TERMINAL_BLOCK_FAILURE',

  FILTER_TERMINAL_BLOCKS_REQUEST = '@terminalBlocks/FILTER_TERMINAL_BLOCKS_REQUEST',
  FILTER_TERMINAL_BLOCKS_SUCCESS = '@terminalBlocks/FILTER_TERMINAL_BLOCKS_SUCCESS',
  FILTER_TERMINAL_BLOCKS_FAILURE = '@terminalBlocks/FILTER_TERMINAL_BLOCKS_FAILURE',

  CREATE_TERMINAL_BLOCK_REQUEST = '@terminalBlocks/CREATE_TERMINAL_BLOCK_REQUEST',
  CREATE_TERMINAL_BLOCK_SUCCESS = '@terminalBlocks/CREATE_TERMINAL_BLOCK_SUCCESS',
  CREATE_TERMINAL_BLOCK_FAILURE = '@terminalBlocks/CREATE_TERMINAL_BLOCK_FAILURE',

  UPDATE_TERMINAL_BLOCK_REQUEST = '@terminalBlocks/UPDATE_TERMINAL_BLOCK_REQUEST',
  UPDATE_TERMINAL_BLOCK_SUCCESS = '@terminalBlocks/UPDATE_TERMINAL_BLOCK_SUCCESS',
  UPDATE_TERMINAL_BLOCK_FAILURE = '@terminalBlocks/UPDATE_TERMINAL_BLOCK_FAILURE',

  DELETE_TERMINAL_BLOCK_REQUEST = '@terminalBlocks/DELETE_TERMINAL_BLOCK_REQUEST',
  DELETE_TERMINAL_BLOCK_SUCCESS = '@terminalBlocks/DELETE_TERMINAL_BLOCK_SUCCESS',
  DELETE_TERMINAL_BLOCK_FAILURE = '@terminalBlocks/DELETE_TERMINAL_BLOCK_FAILURE',
}

/*
 * Data types
 */
export interface BoundsInterface {
  lat: number;
  lng: number;
}

export interface TerminalBlockInterface {
  id: string;
  name: string;
  bounds: BoundsInterface[];
  terminalId: string;
  Terminal?: TerminalInterface;
  Lines?: LineInterface[];
  createdAt: string;
  updatedAt: string;
}

export interface BlockScheduleToggleStatus {
  id: string;
  title: string;
  status: boolean | null;
  weekdays: string;
  validFrom: Date | null;
  type: number | null;
  createdAt: Date | null;
  updatedAt: Date | null;
  blockId: string;
}

/*
 * State type
 */
export interface TerminalBlocksState {
  readonly terminalBlocksList: TerminalBlockInterface[];
  readonly terminalBlockData: TerminalBlockInterface;
  readonly terminalBlockScheduleData: TerminalBlockInterface;
  readonly toggleBlockScheduleStatus: BlockScheduleToggleStatus;
  readonly toggleTerminalPanic: any;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
